import { useState, useEffect } from "react";

// Custom hook for handling authentication logic
const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check initial authentication status from localStorage
  useEffect(() => {
    const userAuthStatus = localStorage.getItem("isAuthenticated");
    setIsAuthenticated(userAuthStatus === "true");
    setLoading(false);
  }, []);

  // Listen for changes to localStorage to trigger re-render
  useEffect(() => {
    const handleStorageChange = () => {
      const userAuthStatus = localStorage.getItem("isAuthenticated");
      setIsAuthenticated(userAuthStatus === "true");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const login = () => {
    localStorage.setItem("isAuthenticated", "true");
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("Token");
    localStorage.removeItem("userName");
    localStorage.removeItem("coachemail");
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    login,
    logout,
    loading,
  };
};

export default useAuth;
